import { render, staticRenderFns } from "./Existencias.vue?vue&type=template&id=2d938578"
import script from "./Existencias.vue?vue&type=script&lang=js"
export * from "./Existencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports